import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  CmsConfig,
  ConfigModule,
  FeaturesConfigModule,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core';
import { ListNavigationModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CheckoutOrderListModule } from 'src/app/spartacus/commonComponents/checkout/checkout-order-list/checkout-order-list.module';
import { CheckoutOrderSummaryModule } from 'src/app/spartacus/commonComponents/checkout/checkout-order-summary/checkout-order-summary.module';
import { CheckoutShipToRddModule } from 'src/app/spartacus/commonComponents/checkout/checkout-ship-to-rdd/checkout-ship-to-rdd.module';
import { OrderDetailsComponent } from './order-details.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgSelectModule,
    ListNavigationModule,
    UrlModule,
    I18nModule,
    FeaturesConfigModule,
    BsDatepickerModule.forRoot(),
    CheckoutOrderListModule,
    CheckoutOrderSummaryModule,
    CheckoutShipToRddModule,
    ConfigModule.withConfig({
      cmsComponents: {
        orderDetailsPOShipToRDDComponent: {
          component: OrderDetailsComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [OrderDetailsComponent],
  exports: [OrderDetailsComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        orderDetailsPOShipToRDDComponent: {
          component: OrderDetailsComponent,
        },
      },
    }),
  ],
})
export class OrderDetailsModule {}
